import {
  getPdfBlobFromInvoiceDraft,
  getPdfBlobFromInvoiceElement,
} from "./invoicePdfVector";

export { getPdfBlobFromInvoiceDraft, getPdfBlobFromInvoiceElement };

/** Finance / Xero-style invoices use the same vector HTML → pdfMake pipeline. */
export const getPdfBlobFromFinanceInvoiceDraft = getPdfBlobFromInvoiceDraft;

export function downloadPdfBlob(blob, filename = "invoice.pdf") {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

export async function createPdfFromFinanceInvoiceDraft(
  draft,
  filename = "invoice.pdf",
) {
  const blob = await getPdfBlobFromFinanceInvoiceDraft(draft);
  downloadPdfBlob(blob, filename);
}

export async function createPdfFromInvoiceElement(
  element,
  filename = "invoice.pdf",
) {
  const blob = await getPdfBlobFromInvoiceElement(element);
  downloadPdfBlob(blob, filename);
}
